/**
 * Sidebar walkthrough for Time & Attendance — first time the module is available.
 * Runs after the product welcome tour when the user has timekeeping.module.
 */

export const PEOPLE_TA_NAV_TOUR_ID = "people-ta-nav-v1";

export const PEOPLE_TA_NAV_TOUR_STEPS = [
  {
    id: "people-section",
    route: "/home",
    selector: "[data-tour='nav-people']",
    title: "Time & Attendance is here",
    description:
      "Under People you will find your Time & Attendance tools: Dashboard, Leave, Time, and Approvals (when you are a manager).",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-dashboard",
    route: "/home",
    selector: "[data-tour='nav-ta-dashboard']",
    title: "Dashboard",
    description:
      "Start here each day — hours, missed logs, and leave balances in one place.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-attendance",
    route: "/home",
    selector: "[data-tour='nav-ta-attendance']",
    title: "Daily Attendance",
    description:
      "Colombia team members plan office / home office / TDY days on this calendar.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-leave",
    route: "/home",
    selector: "[data-tour='nav-ta-leave']",
    title: "Leave",
    description:
      "Request time off, see Available vs Booked, and track approvals.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-time",
    route: "/home",
    selector: "[data-tour='nav-ta-time']",
    title: "Time",
    description:
      "Log weekly hours by job, certify the pay period, and download timesheet PDFs.",
    placement: "right",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
  {
    id: "nav-approvals",
    route: "/home",
    selector: "[data-tour='nav-ta-approvals']",
    title: "Approvals",
    description:
      "If you approve leave or timesheets, your inbox lives here.",
    placement: "right",
    expandSection: "people",
  },
  {
    id: "finish",
    route: "/people/my-day",
    selector: "[data-tour='myday-masthead']",
    title: "Open Dashboard anytime",
    description:
      "Each page also has a Quick start button for a short walkthrough of that screen. You are ready to use Time & Attendance.",
    placement: "bottom",
    expandSection: "people",
    requirePermission: "timekeeping.module",
  },
];
